import { useSelector } from 'react-redux';
import { templateModuleSelectors } from '../../../../../../entities/template-module';
import {
	templateTagsSettingsSelectors,
} from '../../../../../../entities/template/private-template-tag-settings/slice/templateTagsSettingsSlice';
import { useAppSelector } from '../../../../../../shared/libs/redux';
import { workshopModuleSelectors } from '../../../../../../entities/module/workshop-module';
import {
	templateModuleTagsSettingsSelectors,
} from '../../../../../../entities/module/private-template-module-tag-settings/slice/templateModuleTagsSettingsSlice';
import {
	workshopModuleTagsSettingsSelectors,
} from '../../../../../../features/module/tag-group/workshop-module-tag-group-settings/slice/workshopModuleTagsSettingsSlice';
import {
	templateTagGroupSelectors,
} from '../../../../../../entities/template/private-template-tag-group/model/slice/privateTemplateTagGroupSlice';
import {
	templateModuleTagGroupSelectors,
} from '../../../../../../entities/template/private-template-tag-group/template-tag-group/model/template/slice/privateTemplateModuleTagGroupSlice';
import {
	privateTemplateModuleTagSelectors,
} from '../../../../../../entities/module/private-template-module-tag/model/template-module-tag/slice/templateModuleTagSlice';
import {
	workshopModuleTagSelectors,
} from '../../../../../../entities/module/private-template-module-tag/model/workshop-module-tag/slice/workshopModuleTagSlice';
import { useBodyOverflow } from '../../../../../../hooks/useBodyOverflow';
import {
	workshopModuleTagGroupSelectors,
} from '../../../../../../entities/module/tag-group/workshop-module-tag-group/model/slice/workshopModuleTagGroupSlice';

export const useModalStates = () => {
	const isActive = useSelector(templateModuleSelectors.getIsTemplateModuleActive);
	const isEditModalActive = useSelector(templateModuleSelectors.getIsEditTemplateModuleActive);
	const isTagsSettingsModalActive = useSelector(templateTagsSettingsSelectors.getIsTagsSettingsModalActive);
	const isBindingTemplateModuleActive = useAppSelector(templateModuleSelectors.getIsBindingTagModuleModalActive);
	const isBindingWorkshopModuleActive = useAppSelector(workshopModuleSelectors.getIsBindingTagModuleModalActive);
	const isCreateWorkshopModuleGroupModalActive = useSelector(templateTagGroupSelectors.getIsCreateGroupModalActive);
	const isCreatePrivateTemplateModuleGroupModalActive = useSelector(
		templateModuleTagGroupSelectors.getIsCreateGroupModalActive,
	);
	const isDeleteGroupModalActive = useSelector(privateTemplateModuleTagSelectors.getIsDeleteModuleTagModalActive);
	const isDeleteWorkshopGroupModalActive = useSelector(workshopModuleTagSelectors.getIsDeleteModuleTagModalActive);
	const isEditWorkshopModuleTagModalActive = useSelector(workshopModuleTagSelectors.getIsEditingModuleTagModalActive);
	const isEditModuleTagModalActive = useSelector(privateTemplateModuleTagSelectors.getIsEditingModuleTagModalActive);

	const isTemplateModuleTagsSettingsModalActive = useSelector(
		templateModuleTagsSettingsSelectors.getIsTagsSettingsModalActive,
	);

	const isWorkshopModuleTagsSettingsModalActive = useSelector(
		workshopModuleTagsSettingsSelectors.getIsTagsSettingsModalActive,
	);

	const isCreateTemplateModuleGroupModalActive = useSelector(
		templateModuleTagGroupSelectors.getIsCreateGroupModalActive,
	);

	const modalStates = [
		isActive,
		isEditModalActive,
		isDeleteGroupModalActive,
		isCreateWorkshopModuleGroupModalActive,
		isTagsSettingsModalActive,
		isEditModuleTagModalActive,
		isBindingTemplateModuleActive,
		isBindingWorkshopModuleActive,
		isDeleteWorkshopGroupModalActive,
		isEditWorkshopModuleTagModalActive,
		isCreateWorkshopModuleGroupModalActive,
		isCreateTemplateModuleGroupModalActive,
		isTemplateModuleTagsSettingsModalActive,
		isWorkshopModuleTagsSettingsModalActive,
		isCreatePrivateTemplateModuleGroupModalActive,
	];

	useBodyOverflow(modalStates);

	return {
		isActive,
		isEditModalActive,
		isDeleteGroupModalActive,
		isCreateGroupModalActive: isCreateWorkshopModuleGroupModalActive,
		isTagsSettingsModalActive,
		isEditModuleTagModalActive,
		isBindingTemplateModuleActive,
		isBindingWorkshopModuleActive,
		isDeleteWorkshopGroupModalActive,
		isEditWorkshopModuleTagModalActive,
		isCreateWorkshopModuleGroupModalActive,
		isCreateTemplateModuleGroupModalActive,
		isTemplateModuleTagsSettingsModalActive,
		isWorkshopModuleTagsSettingsModalActive,
		isCreatePrivateTemplateModuleGroupModalActive,
	};
};
